import React, { useEffect, useState, useRef } from 'react';
import { useBranchContext } from '../../components/Context/BranchContext';
import { FormControl, Select, MenuItem, Checkbox, ListItemText } from '@mui/material';
import { useSnackbar } from '../SnackBar';
import { usePartnerContext } from '../../components/Context/PartnerContext';
import { useProgressBar } from '../ProgressBar';
import { useNavigate } from 'react-router-dom';

const NewEmployeeAdd = () => {
    const navigate = useNavigate();
    const nameRef = useRef();
    const emailRef = useRef();
    const phoneRef = useRef();
    const branchRef = useRef();
    const { branches, FetchBranches } = useBranchContext();
    const { Addemployee } = usePartnerContext();
    const { showSnackbar } = useSnackbar();
    const didFetch = useRef(false);
    const { showProgress } = useProgressBar();
    const [allowLogin, setAllowLogin] = useState(false);

    const getData = async () => {
        try {
            await FetchBranches();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
            getData();
            didFetch.current = true; // Mark the API call as done
        }
    }, []);

    const [positionName, setPositionName] = useState("");
    const handleChange = (event) => { setPositionName(event.target.value); };

    const [branchName, setBranchName] = useState("");
    const handleBranchSelection = (event) => {
        setBranchName(event.target.value);
    };

    const [specializationName, setspecializationName] = useState([]);
    const { partners, AddPartners, checkEmailExistance } = usePartnerContext();

    const handlespecializationChange = (event) => {
        const { target: { value } } = event;
        setspecializationName(typeof value === 'string' ? value.split(',') : value);
    };
    const formRef=useRef([]);
    const handleClick=()=>{
        const formElements=formRef.current.elements;
        for(let element of formElements){
            if((element.tagName==="INPUT" && element.type!='button')|| element.tagName === 'SELECT'){
                if(element.value==""){
                    element.style.borderColor='red';
                }else{
                    element.style.borderColor='';
                }
            }
            
        }
    }
    const emptyFieldCheck=(e)=>{
        if(e.target.value===""){
            e.target.style.borderColor='';
        }else{
            e.target.style.borderColor='';
        }
        
    };
    const[emailformat,setFormat]=useState(false);
    const[isValidEmail,setEmailExists]=useState(false);
    const checkEmail=async()=>{
        const emailRegExp=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(emailRef.current.value!=""){
            if(emailRegExp.test(emailRef.current.value)){
                setFormat(false) 
            }else{
                setFormat(true);
            }
            const resp = await checkEmailExistance(emailRef.current.value);
            setEmailExists(resp)
        }
    };
    const [phoneNumber,setPhoneNumber]=useState('');
    const[isValid,setIsValid]=useState(false);
    const validatePhoneNumber=(e)=>{
        const number=e.target.value.trim();
        const phoneRegExp= /^\u002B9665\d{8}$/;
        if(number!=""){
            if(phoneRegExp.test(number)){
                setIsValid(false);
            }else{
              setIsValid(true);   
            }
        }
    }
    const handleAddEmployee = async () => {
        if (nameRef.current.value.trim() === '' || emailRef.current.value.trim() === '' || phoneRef.current.value.trim() === '') {
            showSnackbar('Employee cannot be blank', 'error');
            handleClick();
            return;
        }
        showProgress(true);      

  const d=await Addemployee({
            id: 0,
            name: nameRef.current.value.trim(),
            email: emailRef.current.value.trim(),
            phone: phoneRef.current.value.trim(),
            specialization: specializationName,
      position: positionName,
      isActive: true,
      branchName:"",
      branchId: branchName,
      allowLogin: allowLogin 
        });
        showSnackbar('Employee added successfully', 'success');
        showProgress(false);
        setTimeout(() => {
            navigate(`/editemployee/${d.id}/false`);
        }, 2000);
        

    };

    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <h1>Employee</h1>
                <nav>
                    <ol class="breadcrumb">
                    <li className="breadcrumb-item"><a href="/allemployee">Home</a></li>
                        <li className="breadcrumb-item"><a href="/allemployee">Employees</a></li>
                        <li className="breadcrumb-item active"><a href="/employeeadd">New Employee</a></li>
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Employee Details</h5>
                                <div>
                                    <form ref={formRef}>
                                        {/* Name Input */}
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Name</label>
                                            <div className="col-sm-8">
                                                <input type="text" className="form-control" ref={nameRef} style={{ width: '250px' }} onBlur={(e)=>{ emptyFieldCheck(e); }}/>
                                            </div>
                                        </div>

                                        {/* Email Input */}
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Email</label>
                                            <div className="col-sm-8">
                                                <input type="email" className="form-control" ref={emailRef} style={{ width: '250px',borderColor:(isValidEmail === true||emailformat === true)?'red':''}} onBlur={(e)=>{ checkEmail(); emptyFieldCheck(e); }}/>
                                                {emailformat===true && (<div className="form-text text-danger">{ emailformat===true ? "Invalid Email format":"" }</div>)}
                                                {isValidEmail===true && (<div className="form-text text-danger">{isValidEmail===true ? "Email already exists":""}</div>)}
                                            </div>
                                        </div>

                                        {/* Phone Input */}
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Phone</label>
                                            <div className="col-sm-8">
                                                <input type="phone" className="form-control" ref={phoneRef} style={{ width: '250px',borderColor:(isValid===true)?'red':''}} onBlur={(e)=>{ 
                                                    setPhoneNumber(e.target.value);
                                                    validatePhoneNumber(e);
                                                    emptyFieldCheck(e); 
                                                    }}/>
                                                {isValid===true && (<div className="form-text text-danger">{isValid===true ? "Invalid phone number. Please check the format.":""}</div>)}
                                            </div>
                                        </div>

                                        {/* Position Select */}
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Position</label>
                                            <div className="col-sm-6">
                                                <FormControl fullWidth sx={{ width: '250px' }}>
                                                    <Select
                                                        value={positionName}
                                                        onChange={handleChange}
                                                        sx={{
                                                            width: '250px',
                                                            "& .MuiOutlinedInput-root": {},
                                                            "& .MuiSelect-select": { padding: '8px 12px' }
                                                        }}
                                                    >
                                                        <MenuItem value="Supervisor">Supervisor</MenuItem>
                                                        <MenuItem value="Technician">Technician</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>

                                        {/* Specialization Select */}
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Specialization</label>
                                            <div className="col-sm-6">
                                                <FormControl fullWidth sx={{ width: '250px' }}>
                                                    <Select
                                                        labelId="demo-multiple-checkbox-label"
                                                        id="demo-multiple-checkbox"
                                                        multiple
                                                        value={specializationName}
                                                        onChange={handlespecializationChange}
                                                        renderValue={(selected) => selected.join(", ")}
                                                    >
                                                        <MenuItem value="Washer">
                                                            <Checkbox checked={specializationName.includes("Washer")} />
                                                            <ListItemText primary="Washer" />
                                                        </MenuItem>
                                                        <MenuItem value="Mechanic">
                                                            <Checkbox checked={specializationName.includes("Mechanic")} />
                                                            <ListItemText primary="Mechanic" />
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>

                                        {/* Branch Select */}
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Branch</label>
                                            <div className="col-sm-6">
                                                <FormControl fullWidth sx={{ width: '250px' }}>
                                                    <Select
                                                        ref={branchRef}
                                                        value={branchName}
                                                        onChange={handleBranchSelection}
                                                        sx={{
                                                            width: '250px',
                                                            "& .MuiOutlinedInput-root": {},
                                                            "& .MuiSelect-select": { padding: '8px 12px' }
                                                        }}
                                                    >
                                                        {branches.map((branch) => (
                                                            <MenuItem key={branch.id} value={branch.id}>{branch.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>

                                        {/* Allow Login Checkbox */}
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">Allow Login</label>
                                            <div className="col-sm-6">
                                                <div className="form-check mt-2">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="allowLoginCheckbox"
                                                        checked={allowLogin}
                                                        onChange={(e) => setAllowLogin(e.target.checked)}
                                                    />
                                                    <label className="form-check-label" htmlFor="allowLoginCheckbox">
                                                        Yes, allow this employee to log in
                                                    </label>
                                                </div>
                                            </div>
                                        </div>


                                        {/* Save Button */}
                                     
                                        <div className="col-12 d-flex justify-content-end align-items-end" style={{ minHeight: "100px" }}>
                                            <button
                                                type="button"
                                                onClick={handleAddEmployee}
                                                className="btn btn-primary px-3 py-2"
                                            >
                                                Save
                                            </button>
                                        </div>
                                        
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default NewEmployeeAdd;
